import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { BusinessHourDetail, StoreRes } from 'src/app/share/types';
import {
  getStoreInfo,
  selectStoreInfoFeature,
} from 'src/app/state/store-info/selectors';
import { StoreInfoStoreModule } from 'src/app/state/store-info/store-info.store.module';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'uo-full-footer',
  templateUrl: './full-footer.component.html',
  styleUrls: ['./full-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullFooterComponent implements OnInit, OnDestroy {
  store!: StoreRes;
  storeSub!: Subscription;
  mapError: boolean = false;

  businessHours: { day: string; scope: BusinessHourDetail[] }[] = [
    { day: 'Sun', scope: [] },
    { day: 'Mon', scope: [] },
    { day: 'Tue', scope: [] },
    { day: 'Wed', scope: [] },
    { day: 'Thu', scope: [] },
    { day: 'Fri', scope: [] },
    { day: 'Sat', scope: [] },
  ];

  constructor(
    private storeStore$: Store<StoreInfoStoreModule>,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.getStore();
  }
  getStore(): void {
    this.storeSub = this.storeStore$
      .select(selectStoreInfoFeature)
      .pipe(select(getStoreInfo))
      .subscribe((res) => {
        console.log('getStoreInfo :>> ', res);
        if (res) {
          this.store = res;
          this.store.business_hour?.forEach((b) => {
            (
              Object.entries(JSON.parse(b.scope)) as [
                '1' | '2' | '3' | '4' | '5' | '6' | '0',
                boolean
              ][]
            ).forEach((d) => {
              if (d[1]) {
                this.businessHours[d[0]].scope?.push({
                  open_hour: b.open_hour,
                  close_hour: b.close_hour,
                });
              }
            });
          });
          console.log('this.businessHours :>> ', this.businessHours);
          console.log('this.store :>> ', this.store);
          this.cdr.markForCheck();
        }
      });
  }

  getStaticMapUrl(): string {
    const apiKey = environment.googleMapsApiKey;
    let center: string;
    let marker: string = '';

    // Try to use coordinates first (more accurate)
    if (this.store?.latitude && this.store?.longitude) {
      const lat = parseFloat(this.store.latitude.toString());
      const lng = parseFloat(this.store.longitude.toString());
      
      // Validate coordinates
      if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
        center = `${lat},${lng}`;
        marker = `&markers=color:red|${lat},${lng}`;
      } else {
        // Invalid coordinates, fall back to address
        center = this.getAddressString();
        if (center) {
          marker = `&markers=color:red|${encodeURIComponent(center)}`;
        }
      }
    } else {
      // No coordinates, use address
      center = this.getAddressString();
      if (center) {
        marker = `&markers=color:red|${encodeURIComponent(center)}`;
      }
    }

    if (!center) {
      return '';
    }

    const url = `https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(center)}&zoom=17&size=640x400${marker}&key=${apiKey}`;
    console.log('Static map URL:', url);
    return url;
  }

  private getAddressString(): string {
    if (!this.store) {
      return '';
    }
    const addressParts = [
      this.store.address,
      this.store.city,
      this.store.state,
      this.store.zipcode?.toString(),
    ].filter(Boolean);
    
    return addressParts.join(', ') || '';
  }

  getGoogleMapsLink(): string {
    if (!this.store) {
      return '';
    }
    // Use store name with address to get the business place page
    const query = this.store.store_name 
      ? `${this.store.store_name}, ${this.store.address}, ${this.store.city}, ${this.store.state} ${this.store.zipcode}`
      : `${this.store.address}, ${this.store.city}, ${this.store.state} ${this.store.zipcode}`;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  }

  onImageError(event: Event): void {
    console.error('Failed to load static map image:', event);
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
    this.mapError = true;
    this.cdr.markForCheck();
  }
}
